<template>
	<div class="user-info">
		<div v-if="sourceObj == 'load'" class="loading-animation"><div class="box"><span></span></div></div>
		<p v-else-if="sourceObj == {}" class="shift">没有相关数据！</p>
		<tjkUserInfo
			v-else-if="tjkId"
			:tjkId="tjkId"
			:sessionId="currentConversation ? currentConversation.id : null"
			:extInfos="sourceObj && sourceObj.imWebExtInfos ? sourceObj.imWebExtInfos : []"
			@getTjkInfoErr="() => sourceObj = {}"
		/>
		<qxUserInfo
			v-else-if="isQxUser"
			:extInfos="sourceObj && sourceObj.imWebExtInfos ? sourceObj.imWebExtInfos : []"
			@getTjkInfoErr="() => sourceObj = {}"
		/>
		<dl v-else>
			<dd>
				<label>来源：</label>{{ sourceObj.fromurl }}
			</dd>
			<dd>
				<label>地址：</label>{{ sourceObj.addr }}
			</dd>
			<dd>
				<label>渠道：</label>
				<span v-if="sourceObj.platform == 0">WEB</span>
				<span v-else-if="sourceObj.platform == 1">微信</span>
				<span v-else-if="sourceObj.platform == 2">IOS</span>
				<span v-else-if="sourceObj.platform == 3">安卓</span>
				<span v-else>其他</span>
			</dd>
			<dd>
				<label>终端：</label>{{ sourceObj.device }}
			</dd>
			<dd>
				<label>外部链接：</label>
				<template v-if="sourceObj.outerLink">
					<a v-for="link in sourceObj.outerLink" :href="link.url" target="_blank" style="margin-right: 10px">{{ link.name }}</a>
				</template>
			</dd>
			<template v-if="sourceObj.imWebExtInfos">
				<dd v-for="ext in sourceObj.imWebExtInfos" style="word-wrap: break-word;word-break:break-all;">
					<label>{{ ext.name }}：</label>{{ ext.value }}
				</dd>
			</template>
		</dl>
	</div>
</template>

<script>
import bus from '@/config/eventBus'
import tjkUserInfo from './tjkUser.vue'
import qxUserInfo from './qxUser.vue'
export default {
	name: 'wxSource',
	components: { tjkUserInfo, qxUserInfo },
	data () {
		return {
			sourceObj: {},
			tjkId: null,
			isQxUser: false
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	watch: {
		currentConversation: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id || !now.id) return;
				this.getSource();
			}
		}
	},
	created() {
		bus.$on('wxSource_getSource_', () => {
			this.getSource();
		})
	},
	methods: {
		// 获取用户来源
		getSource () {
			var self = this,
				data = {
					"serviceType": self.currentShop.serviceType,
					"sessionId": self.currentConversation.id
				};

			self.sourceObj = 'load';
			self.tjkId = null;
			self.isQxUser = false;

			self.$axios.post(API_ROOT.url + '/SessionApi.getClientExtInfo', data).then(result => {
				if (result.status) {
					var obj = (result.data && result.data.session) ? result.data.session : null;
					if (obj) {
						obj.outerLink = result.data.outerLink;
						if (!obj.imWebExtInfos) obj.imWebExtInfos = result.data.imWebExtInfos;
					}

					if (obj && obj.imWebExtInfos) {
						for (let i = 0; i < obj.imWebExtInfos.length; i++) {
							let item = obj.imWebExtInfos[i];
							if (item.name == 'tjkId') {
								self.tjkId = item.value;
								break;
							} else if (item.name == 'qxjike_product_no' || item.name == 'qxjike_user_id') {
								self.isQxUser = true;
								break;
							}
						}
					}

					self.sourceObj = obj || {};
					this.$emit('initSuccess', obj.imWebExtInfos || [])
				} else {
					self.sourceObj = {};
					self.$message.error('获取用户来源失败，失败原因：' + result.msg);
				}
			}, response => {
				self.sourceObj = {};
				self.$message.error('获取用户来源失败，错误码(' + response + ')');
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/aside/wxSource.vue